import React from 'react';
import PropTypes from 'prop-types';

import AboutContent from '../AboutContent';
import CoachInfo from '../CoachInfo';
import CollegeProspectInfo from '../CollegeProspectInfo';
import styles from './TabContentStudent.scss';
import useIsMobile from '../../hooks/useIsMobile';

const TabContentStudent = (props) => {
    const {
        className,
        profileData,
        displayCollegeRecruitingValues,
        isOwnProfile,
        isOverviewTab,
    } = props;

    const { isMobileWidth } = useIsMobile();
    const showAboutSection = isMobileWidth ? isOverviewTab : true;
    const coach = profileData?.studentInfo?.coach;
    const hasCoachContact = coach?.firstName && coach?.lastName;

    return (
        <div className={`tab-content ${className || ''}`}>
            <div className="container">
                <div className="row">
                    <div className={`col-12 col-md-8 mt48 d-none d-md-block`}>
                        <h6 className="text-semi" data-testid="profile.student-info.high-school-title">High School</h6>
                        {props.children ? props.children : 'No Component Provided'}
                    </div>
                    <div className={`col-12 col-md-4`}>
                        {showAboutSection && profileData && (
                            <div>
                                <AboutContent
                                    className={`mt0`}
                                    profileData={profileData}
                                    displayCollegeRecruitingValues={displayCollegeRecruitingValues}
                                />
                            </div>
                        )}
                        <div className={`d-block d-md-none`}>
                            <h6 className="text-semi mt48" data-testid="profile.student-info.high-school-title-mobile">High School</h6>
                            {props.children ? props.children : 'No Component Provided'}
                        </div>
                        {hasCoachContact ? (
                            <div>
                                <h6 className="text-semi mt48" data-testid="profile.student-info.primary-contact-title">Primary Contact</h6>
                                <CoachInfo
                                    coach={coach}
                                    data-testid="profile.student-info.primary-contact"
                                />
                            </div>
                        ) : (
                            <>
                                {isOwnProfile && (
                                    <div>
                                        <h6 className="text-semi mt48" data-testid="profile.student-info.primary-contact-add-title">Primary Contact</h6>
                                        <a onClick={props.showEditForm} className={`${styles.contactLink}`} data-testid="profile.student-info.add-contact-link">Add Contact Information</a>
                                    </div>
                                )}
                            </>
                        )}
                        <CollegeProspectInfo profileData={profileData} />
                    </div>
                </div>
            </div>
        </div>
    );
};

TabContentStudent.propTypes = {
    displayCollegeRecruitingValues: PropTypes.bool,
    isOverviewTab: PropTypes.bool,
    className: PropTypes.string,
    profileData: PropTypes.shape({
        studentInfo: PropTypes.shape({
            coach: PropTypes.shape({
                firstName: PropTypes.string,
                lastName: PropTypes.string,
            }),
        }),
    }),
    children: PropTypes.node,
    isOwnProfile: PropTypes.bool,
};

TabContentStudent.defaultProps = {
    displayCollegeRecruitingValues: false,
    isOverviewTab: false,
    className: '',
    profileData: {},
    children: null,
    isOwnProfile: false,
};

export default TabContentStudent;
